<template>
	<div class="c-generations-page" v-if="isAuth">
		<Generations></Generations>
	</div>
</template>

<script>
import Generations from '@swipekit/components/generations';

export default {
	components: {
		Generations,
	},

	computed: {
		isAuth: function () {
			return this.$store.getters['users/isAuth'];
		},
	},
};
</script>

<style lang="scss">
.c-generations-page {
}
</style>
